import React, { FC } from 'react';

import ButtonPrimary, { IButtonPrimaryProps } from '../Primary';

export type IButtonOutlineProps = Omit<IButtonPrimaryProps, '$isOutline'>;

const ButtonOutline: FC<IButtonOutlineProps> = (props) => (
  <ButtonPrimary
    {...props}
    $isOutline
  />
);

export default ButtonOutline;
